import { Form } from 'antd';
import FormLayout from './FormLayout';
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { CASE_FORM_TYPES } from '../../../appContants';
import {
  mapAntFileToServerFile,
  mapCaseToPatientDetails,
  mapCaseToServices,
  mapCaseToStudyPurpose,
  mapCaseToUpload,
  mapPatientDetailsToCase,
  mapServicesToCase,
  mapStudyPurposeToCase,
} from '../../../utils/case';
import apiService from '../../../axios/apiService';
import { AxiosError } from 'axios';
import { BAD_REQUEST_STATUS_CODE } from '../../../axios/constants';
import { notification } from 'antd';
import {usePaymentMethod} from '../../../hooks/usePaymentMethod';
import {getInvoiceTypeText} from '../../../utils/clinic';

const CaseForm = ({ initialValues, loading, onSubmit, breadCrumbs, caseId }) => {
  const layoutRef = useRef();
  const formDataRef = useRef({});
  const isCaseSubmitRef = useRef(false);
  const [patientDetailsForm] = Form.useForm();
  const [studyPurposeForm] = Form.useForm();
  const [addServiceForm] = Form.useForm();
  const [uploadFilesForm] = Form.useForm();
  const [api, contentHolder] = notification.useNotification();
  const { selectedLocation: currentLocation} = usePaymentMethod();
  useEffect(() => {
    if (!initialValues) return;

    // Map Case details to input form values
    const initialPatientDetails = mapCaseToPatientDetails(initialValues);
    const initialStudyPurpose = mapCaseToStudyPurpose(initialValues);
    const initialServices = mapCaseToServices(initialValues);
    const initialUploads = mapCaseToUpload(initialValues);

    // initialize forms with case input data
    initialPatientDetails &&
      patientDetailsForm.setFieldsValue(initialPatientDetails);
    initialStudyPurpose && studyPurposeForm.setFieldsValue(initialStudyPurpose);
    initialServices && addServiceForm.setFieldsValue(initialServices);
    initialUploads && uploadFilesForm.setFieldsValue(initialUploads);
  }, [initialValues]);

  const updateFormDataRef = (name, info) => {
    switch (name) {
      case CASE_FORM_TYPES.patientDetails:
        formDataRef.current = {
          ...(formDataRef?.current || {}),
          ...mapPatientDetailsToCase(info?.values),
        };
        break;
      case CASE_FORM_TYPES.addServices:
        formDataRef.current = {
          ...(formDataRef?.current || {}),
          ...mapServicesToCase(info?.values?.services),
        };
        break;
      case CASE_FORM_TYPES.uploadFiles:
        formDataRef.current = {
          ...(formDataRef?.current || {}),
          files: info?.values?.files?.map(mapAntFileToServerFile),
        };
        break;
      case CASE_FORM_TYPES.studyPurpose:
        formDataRef.current = {
          ...(formDataRef?.current || {}),
          studyPurpose: {
            ...(mapStudyPurposeToCase(info?.values) || {}),
          },
        };
        break;

      default:
        break;
    }
  };
  const createCase = async()=>{
  try {
    let data = {
          ...formDataRef.current,
          files: uploadFilesForm.getFieldsValue()?.files?.map(mapAntFileToServerFile), 
        };
      if(getInvoiceTypeText(currentLocation?.paymentMethod) == 'Monthly')
        data.isSubmitted = true;
      const response = await apiService.createCase(data);
      api.success({
        message: 'Success',
        description: response?.message,
        showProgress: false,
      });
       return response?.data;
      // navigate('/user/case/created');
    } catch (error) {
      if (
        error instanceof AxiosError &&
        error?.response?.status === BAD_REQUEST_STATUS_CODE &&
        !error?.response?.data?.formErrorMessage
      )
        return;
      api.error({
        message: 'Error',
        description: error?.response?.data?.error || error?.message,
        showProgress: false,
      });
    } finally {
      // setLoading(undefined);
    }
  }
  const handleSubmit = async(index,isCreateCase=false) => {
    switch (index) {
      case 0:
        patientDetailsForm?.submit();
        break;
      case 1:
        studyPurposeForm?.submit();
        break;
      case 2:
        addServiceForm?.submit();
        break;
      case 3:
        console.log('✌️isCaseSubmit --->', isCaseSubmitRef.current);
        if(isCreateCase){
          let response = await createCase();
          console.log('✌️response --->', response);
          // Reset the flag after use
          isCaseSubmitRef.current = false;
          return response;
        } else {
          uploadFilesForm?.submit();
        }
        break;
      default:
        break;
    }
  };
  const handleMarkAsSubmitted = async (info) => {
    return onSubmit?.(
      {
        ...(formDataRef?.current || {}),
        markAsSubmitted: true,
        files: info?.files?.map(mapAntFileToServerFile),
      },
      'submitting'
    );
  };

  {contentHolder}
  return (
    <Form.Provider
    onFormFinish={(name, info) => {
        // Update the form data ref with latest form values received
        updateFormDataRef(name, info);
        if (name === CASE_FORM_TYPES.uploadFiles) {
          return onSubmit?.(formDataRef.current);
        } else {
          layoutRef?.current?.goToNextTab();
        }
      }}
    >
      <FormLayout
        ref={layoutRef}
        patientDetailsForm={patientDetailsForm}
        studyPurposeForm={studyPurposeForm}
        addServiceForm={addServiceForm}
        uploadFilesForm={uploadFilesForm}
        loading={loading}
        initialValues={initialValues}
        breadCrumbs={breadCrumbs}
        onMarkAsSubmitted={handleMarkAsSubmitted}
        caseId={caseId}
        handleSubmit={handleSubmit}
        />
    </Form.Provider>
  );
};

CaseForm.propTypes = {
  initialValues: PropTypes.any,
  loading: PropTypes.any,
  onSubmit: PropTypes.func,
  breadCrumbs: PropTypes.array,
  caseId: PropTypes.number,
};

export default CaseForm;
